import { render } from "./CarouselVue.vue?vue&type=template&id=7d3384c2"
import script from "./CarouselVue.vue?vue&type=script&lang=js"
export * from "./CarouselVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__